import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledHistoryComponents = {
  StyledDeleteHistoryText: styled(Box)(({ theme }) => ({
    justifySelf: 'center',
    '&:hover': { color: theme.palette.text.secondary, cursor: 'pointer' },
    marginBottom: '10px'
  }))
};

export default StyledHistoryComponents;
